import React from 'react';
import './Guidelines.scss';

const ConversationLogGuidelines = () => {
    return (
        <div className='guidelines' id='ConversationGuidelines'>
            <p>Discussions reinforce positive behavior and set expectations for future behavior.  Use the Discussion feature to document goal discussion or use it to document other public or private coaching discussions.</p>
            <p>Great Discussion?  Save then send a Shout Out, let their team know about their greatness!</p>
            <p>Did the Discussion generate an idea or action?  Save then create a To-Do to document progress and completion!</p>
        </div>
    );
}

export default ConversationLogGuidelines;
